import { render } from "./inventariomobiliariorestaurante.vue?vue&type=template&id=5f5cf4b4&scoped=true"
import script from "./inventariomobiliariorestaurante.vue?vue&type=script&lang=js"
export * from "./inventariomobiliariorestaurante.vue?vue&type=script&lang=js"

import "./inventariomobiliariorestaurante.vue?vue&type=style&index=0&id=5f5cf4b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5cf4b4"]])

export default __exports__